import script from "./CustomDashboardNestedItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardNestedItems.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardNestedItems.vue?vue&type=style&index=0&id=049868f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049868f0"]])

export default __exports__